<template>
    <div class="d-flex fill-height of-y">
        <div v-if="startingUp" class="fill-height flex-grow-1 d-flex align-center justify-center">
            <app-centre-loader label="Loading Invoices"></app-centre-loader>
        </div>
        <v-scroll-x-transition hide-on-leave>
            <div class="fill-height of-y flex-grow-1" v-if="!startingUp">
                <v-btn @click="runTest">Test</v-btn>
            </div>
        </v-scroll-x-transition>
    </div>
</template>

<script>
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {format} from "date-fns";
import {dateFormats} from "@/core/codeFunctions";
import AppEmployeeSnapshotExplorer from "@/components/Shared/EmployeeSnapshotExplorer/AppEmployeeSnapshotExplorer";

export default {
    components: {AppCentreLoader, AppEmployeeSnapshotExplorer},
    data() {
        return {
            startingUp: false,
            loading: false,
        }
    },
    // mounted() {
    //     this.startup()
    // },
    methods: {
        async runTest() {
            try {
                this.loading = true;
                const res = await this.$newReq("GET", `billing/test`)
                console.log(res)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loading = false;
            }
        },
        async startup() {
            try {
                this.startingUp = true;
                const snapshots = await this.$newReq("GET", `setup/invoices/startup`)
                this.snapshots = snapshots.map(shot => {
                    shot.createdAt = new Date(shot.createdAt)
                    shot.runTime = new Date(shot.runTime)
                    return shot
                })
                console.log(this.snapshots)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.startingUp = false;
            }
        }
    },
    computed: {
        filterStr() {
            return this.$store.state.ref.admin.invoices.filterStr
        },
        invoices() {
            return (this.snapshots && this.snapshots.length ? this.snapshots.map(snap => {

                const {devices: devicesCount, days: daysCount} = snap.snapshot.reduce((summary, employee) => {
                    summary.devices = summary.devices + employee.devices.length
                    summary.days = summary.days + employee.daysUsed
                    return summary
                }, {devices: 0, days: 0});

                return {
                    ...snap,
                    employeesCount: snap.snapshot.length,
                    dateStr: format(snap.runTime, dateFormats.longDateOnly),
                    devicesCount,
                    daysCount,
                }
            }) : [])
                    .filter(shot => this.filterStr ? JSON.stringify(shot).toLowerCase().includes((this.filterStr || '').toLowerCase()) : true)
        },
    },
}
</script>

<style scoped>

</style>